const CognitoConfig = {
  // aws_project_region: 'us-east-1',
  // aws_cognito_identity_pool_id: 'us-west-2:6b9091b3-4e83-4d1f-b951-1421801114fa',
  aws_cognito_region: process.env.REACT_APP_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID
}

exports.Config = CognitoConfig
